export function compararMontos(a, b, tolerancia = 0.01) {
  return Math.abs(a - b) < tolerancia;
}
